import axios from "axios";
const CryptoJS = require("crypto-js");

const key = CryptoJS.AES.encrypt(
	process.env.VUE_APP_API_NAME,
	process.env.VUE_APP_API_KEY
).toString();

const instance = axios.create({
	baseURL: process.env.VUE_APP_HOST_API,
	timeout: 60000,
});

instance.interceptors.request.use(
	(config) => {
		if (key) {
			config.headers.Authorization = key;
		} else {
			delete config.headers.Authorization;
		}
		return config;
	},
	(error) => {
		console.log(error);
	}
);

export default instance;
